import { cn } from "@tine/designsystem-utils";
import type { ReactNode } from "react";
import { WouterLinkWithTracking } from "./Links";

type TagLinkProps = {
   url: string;
   label: ReactNode;
   isActive?: boolean;
   className?: string;
   linkClassName?: string;
   invertedHover?: boolean;
   trackingLocationName?: string;
   linkName?: string;
   onClick?: (e: React.MouseEvent<HTMLElement>) => void;
};

const styles = (isActive: boolean, invertedHover: boolean) =>
   cn("text-nowrap rounded-lg border border-solid border-ink-border-subtle", "px-4 py-2 text-sm", {
      "hover:bg-surface-default-hover bg-surface-default": !invertedHover,
      "bg-surface-default-hover hover:bg-surface-default": invertedHover,
      "bg-button-primary-bg hover:bg-button-primary-bg-hover !text-button-primary-text": isActive
   });

const TagLink = ({
   url,
   label,
   isActive = false,
   className = "",
   linkClassName = "",
   trackingLocationName,
   linkName,
   onClick,
   invertedHover = false
}: TagLinkProps) => (
   <WouterLinkWithTracking
      to={url}
      className={linkClassName}
      trackingLocationName={trackingLocationName}
      linkName={linkName}
      onClick={onClick}
   >
      <div className={cn(styles(isActive, invertedHover), className)}>{label}</div>
   </WouterLinkWithTracking>
);

export default TagLink;
